<div class="widget-journey" *transloco="let wt">
  @if (dataSourceNotFound && !isLoading) {
    <div class="text-center">
      <h1>{{ wt('widgets.data-source-removed-select-another') }}</h1>
    </div>
  }
  <ng-container *transloco="let t; prefix: 'widgets.journey'">
    @if (!dataSourceNotFound) {
      <div class="widget-journey__top-section">
        @if (timelineSubject()) {
          <div class="widget-journey__timeline-controls">
            <div class="widget-journey__timeline-controls-left">
              <span class="widget-journey__back-link" (click)="closeTimelineView()">
                <xi-icon icon="arrow_left" color="CX"></xi-icon>{{ t('back-to-table') }}
              </span>
            </div>

            <div
              class="widget-journey__timeline-controls-right"
              [class.widget-journey__timeline-controls-right--compact]="isCompact()"
            >
              <xi-default-button
                fill="fill"
                [color]="'orca'"
                [tone]="'light'"
                buttonSize="normal"
                [text]="t('view-journey-details')"
                (onClick)="onViewJourneyDetails()"
              ></xi-default-button>

              @if (isCompact()) {
                <xi-icon-button
                  icon="settings"
                  color="CX"
                  [tooltip]="{ text: t('timeline-settings') }"
                  (onClick)="toggleSettingsPopup()"
                  (click)="$event.stopPropagation()"
                ></xi-icon-button>

                @if (showSettingsPopup()) {
                  <div class="widget-journey__settings-popup" (click)="$event.stopPropagation()">
                    <ng-container *ngTemplateOutlet="timelineControlsTemplate"></ng-container>
                  </div>
                }
              } @else {
                <ng-container *ngTemplateOutlet="timelineControlsTemplate"></ng-container>
              }
            </div>
          </div>
        } @else if (widgetDataSource?.isJourneyGroup) {
          <xi-search-box
            [placeholder]="t('search', { header: subjectColumnHeader() })"
            [isFiredOnEnter]="true"
            (onChangeOverride)="onSearchChanged($any($event).detail.searchText)"
            (onCancelClick)="onSearchChanged('')"
          ></xi-search-box>

          <mat-paginator
            [pageSize]="pageSize()"
            [pageIndex]="pageIndex()"
            [length]="pageCount()"
            [pageSizeOptions]="[20, 50, 100]"
            (page)="onPageChanged($event)"
          ></mat-paginator>
          <div class="widget-journey__date-range">
            <span class="widget-journey__date-range-label">{{ t('time-span') }}</span>
            <ng-container *ngTemplateOutlet="calendarTemplate"></ng-container>
          </div>
        }
      </div>

      <div class="widget-journey__container">
        @if (isLoading) {
          <div class="widget-journey__loader-overlay">
            <xi-animation [loop]="true" animation="cx_loader"></xi-animation>
          </div>
        } @else if (noData) {
          <div class="text-center">
            <h1>{{ 'widgets.no-data-found' | transloco }}</h1>
          </div>
        } @else if (timelineSubject()) {
          <div class="widget-journey__timeline" #chartContainer>
            @if (nmotWidget()) {
              <div class="widget-journey__timeline-chart widget-journey__timeline-chart--nmot">
                <app-widget-chart
                  #nmotChartRef
                  [dashboard]="dashboard"
                  [widget]="nmotWidget()!"
                  [widgetDataSource]="widgetDataSource"
                  [project]="project"
                  [preloadedReportResponse]="nmotPreloadedResponse()"
                  (needRedraw)="needRedraw.emit($event)"
                  (loadingStarted)="loadingStarted.emit($event)"
                  (loadingFinished)="onChartLoadingFinished($event)"
                  (goBackClicked)="closeTimelineView()"
                  (reportResponseReady)="onNmotReportResponseReady($event)"
                  (chartRendered)="syncTimelinePlotArea()"
                ></app-widget-chart>
              </div>
            }
            @if (timelineWidget() && !nmotChart()?.noDocuments) {
              <div
                class="widget-journey__timeline-chart widget-journey__timeline-chart--touchpoints"
              >
                <app-widget-chart
                  #timelineChartRef
                  [dashboard]="dashboard"
                  [widget]="timelineWidget()!"
                  [widgetDataSource]="widgetDataSource"
                  [project]="project"
                  [preloadedReportResponse]="sharedReportResponse()"
                  (needRedraw)="needRedraw.emit($event)"
                  (loadingStarted)="onTimelineLoadingStarted($event)"
                  (loadingFinished)="onChartLoadingFinished($event)"
                  (reportResponseReady)="onTimelineReportResponseReady($event)"
                  (xAxisZoomChanged)="onTimelineAxisZoomChanged($event)"
                ></app-widget-chart>
              </div>
              @if (timelineChart()?.isClusterExpanded) {
                <span class="widget-journey__back-link" (click)="backToFullTimeline()">
                  <xi-icon icon="arrow_left" color="CX"></xi-icon>{{ timelineBackLabel() }}
                </span>
              }
              @if (timelineLegendItems().length) {
                <div class="widget-journey__timeline-legend">
                  @for (item of timelineLegendItems(); track $index) {
                    <div class="widget-journey__timeline-legend-item">
                      <span
                        class="widget-journey__timeline-legend-swatch"
                        [style.background-color]="item.color"
                      ></span>
                      <span class="widget-journey__timeline-legend-label">{{ item.label }}</span>
                    </div>
                  }
                </div>
              }
            }
          </div>
        } @else {
          <table #table mat-table [dataSource]="dataSource()" class="widget-journey__table">
            @for (column of displayedColumns(); track column) {
              <ng-container [matColumnDef]="column">
                <th mat-header-cell *matHeaderCellDef class="widget-journey__header">
                  <div class="widget-journey__table-header-content">
                    <div class="widget-journey__header-border"></div>
                    <span>{{ getColumnHeader(column) }}</span>
                  </div>
                </th>
                <td
                  mat-cell
                  *matCellDef="let row"
                  class="widget-journey__cell"
                  [class.widget-journey__cell--subject]="column === 'subjectId'"
                  [class.widget-journey__cell--clickable]="isCellClickable(row, column)"
                  (click)="
                    isCellClickable(row, column) &&
                      openJourneyDetails(row, column === 'totalTouchpoints' ? undefined : column)
                  "
                >
                  @if (column === 'subjectId') {
                    <span class="widget-journey__subject-link" (click)="onSubjectClick(row)">{{
                      row.subjectId
                    }}</span>
                  } @else if (column === 'totalTouchpoints') {
                    {{ row.totalTouchpoints | number }}
                  } @else if (isAnalyticItemColumn(column)) {
                    {{ (row[column] | isValidNumber) ? (row[column] | number: '1.0-2') : '-' }}
                  } @else {
                    {{ (row[column] | isValidNumber) ? (row[column] | number) : 0 }}
                  }
                </td>
              </ng-container>
            }
            <tr
              mat-header-row
              *matHeaderRowDef="displayedColumns(); sticky: true"
              class="widget-journey__header-row"
            ></tr>
            <tr
              mat-row
              *matRowDef="let row; columns: displayedColumns()"
              class="widget-journey__row"
            ></tr>
            <tr class="widget-journey__no-data-row" *matNoDataRow>
              @if (!isLoading) {
                <td [attr.colspan]="displayedColumns().length">
                  {{ t('no-data') }}
                </td>
              }
            </tr>
          </table>
        }
      </div>
    }

    <ng-template #timelineControlsTemplate>
      <xi-dropdown
        [label]="subjectColumnHeader()"
        [data]="availableSubjects()"
        [value]="timelineSubject()"
        [inMenuSearch]="true"
        (onValueChange)="onTimelineSubjectChange($any($event).detail.selected.id)"
      ></xi-dropdown>

      <xi-dropdown
        [label]="t('content-channel')"
        [data]="availableContentChannels()"
        [value]="selectedContentChannels()"
        select="multiSelectAll"
        (onValueChange)="onContentChannelFilterChange($any($event).detail.selected)"
      ></xi-dropdown>

      <ng-container *ngTemplateOutlet="calendarTemplate"></ng-container>
    </ng-template>

    <ng-template #calendarTemplate>
      <xi-calendar
        [placeholder]="calendarPlaceholder()"
        [data]="calendarData()"
        [checkedListId]="calendarCheckedId()"
        [mode]="calendarMode()"
        [popoutView]="true"
        (onToggle)="calendarMode.set($any($event).detail?.mode)"
        (onValueChange)="onCalendarValueChange($any($event))"
      ></xi-calendar>
    </ng-template>
  </ng-container>
</div>

@if (showJourneyDetailsDialog()) {
  <app-lex-xi-modal
    [isVisible]="showJourneyDetailsDialog()"
    maxWidth="80vw"
    (close)="onJourneyDetailsDialogClosed()"
  >
    <ng-template appXIModalContent>
      @if (showJourneyDetailsDialog()) {
        <app-journey-details-dialog
          [options]="journeyDetailsDialogOptions()!"
          (close)="onJourneyDetailsDialogClosed()"
          (documentsChanged)="onJourneyDocumentsChanged()"
        ></app-journey-details-dialog>
      }
    </ng-template>
  </app-lex-xi-modal>
}
